import { useMemo, useState } from "react"

import { FilterButton } from "@l2r-front/l2r-ui"

import { FILTERS } from "../../constants/filters"
import { useEquipmentStateContext } from "../../contexts/EquipmentContext"

import { EquipmentFilters } from "../EquipmentFilters"

export function EquipmentFilterButton(props: EquipmentFilterButtonProps) {

    const {
        className,
        enabledFilters = FILTERS,
    } = props

    const [displayFilters, setDisplayFilters] = useState(false)
    const closeFilters = () => setDisplayFilters(false)
    const toggleFilter = () => setDisplayFilters(displayFilters => !displayFilters)

    const { filters } = useEquipmentStateContext()

    const filterCount = useMemo(() => {
        return Object.entries(filters || {}).map(([filterKey, filterValue]) => {
            if (enabledFilters.includes(filterKey)) {
                return filterValue
            } else {
                return []
            }
        }).flat().length
    }, [filters, enabledFilters])

    return <FilterButton className={className} filterCount={filterCount} open={displayFilters} onClick={toggleFilter} onClose={closeFilters}>
        <EquipmentFilters displayFilters={displayFilters} close={closeFilters} />
    </FilterButton>
}

type EquipmentFilterButtonProps = {
    className?: string
    enabledFilters?: Array<typeof FILTERS[number]>
}
